@if (spinnerService.isLoading()) {
  <div class="spinner-overlay">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
}
